import api from './api';

const passwordService = {
  enviarCorreo: async (email) => {
    const { data } = await api.post('/auth/forgot-password', { email });
    return data;
  },

  resetear: async (email, token, password) => {
    const { data } = await api.post('/auth/reset-password', {
      email, token, password,
    });
    return data;
  },
};

export default passwordService;